import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import ToggleField from '@panneau/field-toggle';

var styles = {"container":"panneau-field-toggles-container"};

var propTypes = {
  name: PropTypes.string,
  value: PropTypes.objectOf(PropTypes.bool),
  toggles: PropTypes$1.toggles,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps = {
  name: null,
  value: null,
  toggles: [],
  disabled: false,
  className: null,
  onChange: null
};
var TogglesField = function TogglesField(_ref) {
  var name = _ref.name,
    value = _ref.value,
    toggles = _ref.toggles,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    className = _ref.className;
  var onToggleChange = useCallback(function (key, newToggleValue) {
    var newValue = _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, key, newToggleValue));
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, 'd-flex', 'flex-column', _defineProperty({
      disabled: disabled
    }, className, className !== null)])
  }, /*#__PURE__*/React.createElement("ul", {
    className: "list-group"
  }, toggles.map(function (_ref3) {
    var toggleKey = _ref3.key,
      _ref3$label = _ref3.label,
      toggleLabel = _ref3$label === void 0 ? null : _ref3$label;
    return /*#__PURE__*/React.createElement("li", {
      key: "toggle-".concat(toggleKey),
      className: "list-group-item"
    }, /*#__PURE__*/React.createElement("label", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement(ToggleField, {
      name: "".concat(name, "[").concat(toggleKey, "]"),
      value: value !== null ? value[toggleKey] || false : false,
      onChange: function onChange(newValue) {
        return onToggleChange(toggleKey, newValue);
      },
      disabled: disabled
    }), toggleLabel ? /*#__PURE__*/React.createElement("span", {
      className: "ms-2"
    }, toggleLabel) : null));
  })));
};
TogglesField.propTypes = propTypes;
TogglesField.defaultProps = defaultProps;

var definition = {
  id: 'toggles',
  component: 'Toggles'
};

export { TogglesField as default, definition };
